import { useQuery } from 'react-query';

import { APIConfiguration } from '@savgroup-front-common/configuration';
import { DOCUMENT_TYPES } from '@savgroup-front-common/constants';
import { CommonAttachmentService } from '@savgroup-front-common/core/api';

import { useGetClientInformation } from '@/view/app/hooks';

const USE_BANNER_URL = 'useBannerUrl';

const useBannerUrl = (): string | undefined => {
  const { clientInformation } = useGetClientInformation();
  const sellerId = clientInformation?.sellerId || clientInformation?.tenantId;

  const cdnUrl = sellerId
    ? `${APIConfiguration.imageCDN}sellers/${sellerId}/${DOCUMENT_TYPES.SELFCARE_BANNER.toLowerCase()}`
    : undefined;

  const { data: resolvedBannerUrl } = useQuery(
    [USE_BANNER_URL, { sellerId }],
    async () => {
      if (!cdnUrl) {
        return clientInformation?.bannerUrl;
      }

      const exists = await CommonAttachmentService.urlExists({ url: cdnUrl });

      return exists ? cdnUrl : clientInformation?.bannerUrl || undefined;
    },
    {
      enabled: !!clientInformation,
      staleTime: Infinity,
    },
  );

  return resolvedBannerUrl;
};

export default useBannerUrl;
